import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { MultiSelectFilterPicker } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { useIoContext } from '~/providers/IoContext';
import DateRangeFilterPicker from '../DateRangeFilterPicker/DateRangeFilterPicker';
import DateRangeWithPresets from '../DateRangeWithPresets/DateRangeWithPresets';
import RadioFilterPicker from '../RadioFilterPicker/RadioFilterPicker';
import { isInitialFilterValue } from '../TableFilters.utils';
import { SearchFilterType } from '../types';
const Filter = (param)=>{
    let { testIdPrefix, label, filter, filterConfig, selectedFilter, onChange, onRemove, onInputBlur, onInputFocus } = param;
    const { getNow } = useIoContext();
    const { t: filterTexts } = useLocaleKeys('common.filter');
    const now = getNow();
    const getFilterPicker = ()=>{
        switch(filterConfig.type){
            case SearchFilterType.DateRangeFilter:
                return /*#__PURE__*/ _jsx(DateRangeFilterPicker, _object_spread({
                    value: selectedFilter,
                    onChange: onChange,
                    onRemove: onRemove,
                    testId: "".concat(testIdPrefix, "-filter-").concat(filter),
                    label: label,
                    onInputFocus: onInputFocus,
                    onInputBlur: onInputBlur,
                    startOpen: isInitialFilterValue(selectedFilter, filterConfig) && filterConfig.removable
                }, filterConfig));
            case SearchFilterType.MultiSelectFilter:
                var _filterConfig_options;
                return /*#__PURE__*/ _jsx(MultiSelectFilterPicker, {
                    bi: {
                        name: 'multi_select_filter'
                    },
                    withSearchbox: filterConfig.withSearchbox,
                    ellipsis: filterConfig.ellipsis,
                    removable: filterConfig.removable,
                    value: selectedFilter,
                    testId: "".concat(testIdPrefix, "-filter-").concat(filter),
                    title: filterConfig.title || label,
                    options: ((_filterConfig_options = filterConfig.options) === null || _filterConfig_options === void 0 ? void 0 : _filterConfig_options.map((option)=>typeof option === 'string' ? {
                            value: option,
                            label: option
                        } : option)) || [],
                    label: label,
                    onChange: onChange,
                    onRemove: onRemove,
                    onInputFocus: onInputFocus,
                    startOpen: isInitialFilterValue(selectedFilter, filterConfig) && filterConfig.removable,
                    onInputBlur: onInputBlur,
                    selectAllByDefault: filterConfig.selectAllByDefault,
                    hideSelectAll: filterConfig.hideSelectAll,
                    selectAllLabel: filterTexts.selectAll(),
                    applyLabel: filterTexts.apply()
                });
            case SearchFilterType.DateRangeWithPresets:
                return /*#__PURE__*/ _jsx(DateRangeWithPresets, {
                    now: now,
                    startDate: selectedFilter.dateRange[0],
                    endDate: selectedFilter.dateRange[1],
                    dataRangeOption: selectedFilter.dateRangeOption,
                    customDateLimits: filterConfig.customDateLimits,
                    onApply: (dataRange, startDate, endDate)=>{
                        onChange({
                            dateRange: [
                                startDate,
                                endDate
                            ],
                            dateRangeOption: dataRange
                        });
                    },
                    onRemove: onRemove,
                    removable: filterConfig.removable,
                    testIdPrefix: testIdPrefix,
                    title: label,
                    startOpen: filterConfig.startOpen
                });
            case SearchFilterType.RadioFilter:
                var _filterConfig_options1;
                return /*#__PURE__*/ _jsx(RadioFilterPicker, {
                    selectedValue: selectedFilter,
                    defaultLabel: label,
                    defaultValue: filterConfig.defaultOption,
                    title: filterConfig.title || label,
                    testId: "".concat(testIdPrefix, "-filter-").concat(filter),
                    options: ((_filterConfig_options1 = filterConfig.options) === null || _filterConfig_options1 === void 0 ? void 0 : _filterConfig_options1.map((option)=>typeof option === 'string' ? {
                            value: option,
                            label: option
                        } : option)) || [],
                    onApply: (aggregate)=>onChange(aggregate),
                    onRemove: onRemove,
                    removable: filterConfig.removable,
                    startOpen: isInitialFilterValue(selectedFilter, filterConfig) && filterConfig.removable
                });
            case SearchFilterType.CustomFilter:
                {
                    const CustomComponent = filterConfig.component;
                    return /*#__PURE__*/ _jsx(CustomComponent, {
                        value: selectedFilter,
                        startOpen: isInitialFilterValue(selectedFilter, filterConfig) && filterConfig.removable,
                        onChange: onChange,
                        onRemove: onRemove,
                        onInputFocus: onInputFocus,
                        onInputBlur: onInputBlur
                    });
                }
        }
    };
    return getFilterPicker();
};
export default Filter;
